import React from 'react';
import { styled } from '@mui/material/styles';
import { useDroppable } from '@dnd-kit/core';


const StyledRow = styled('div', {
    shouldForwardProp: (prop) => !['rowHeight', 'isOver'].includes(prop),
})(({ theme, rowHeight, isOver }) => ({
    position: 'relative',
    zIndex: 0,
    width: '100%',
    height: rowHeight,
    backgroundColor: isOver ? theme.palette.action.hover : 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: 'background-color 0.15s ease',
    boxSizing: 'border-box',
}));

const DroppableRow = ({ objectId, rowHeight = 50, children }) => {
    const { setNodeRef, isOver } = useDroppable({ id: objectId });

    return (
        <StyledRow ref={setNodeRef} rowHeight={rowHeight} isOver={isOver}>
            {children}
        </StyledRow>
    );
};

export default React.memo(DroppableRow);
